import React from "react";
import PropTypes from "prop-types";
import { AvatarGroupItem } from "@fluentui/react-components";
import FluentUiIcon from "../../assets/fluent-ui-icon";

const PlusIcon = ({ func, disabled, projectId = 0 }) => {
  const plusIconDisabled = disabled || projectId === 0;

  return (
        <AvatarGroupItem
          size={28}
          color={plusIconDisabled ? "anchor" : "transparent"}
          className="list-avatar-multi-owner plus-icon-style"
          style={{
            cursor: plusIconDisabled ? "not-allowed" : "pointer",
            opacity: plusIconDisabled ? 0.5 : 1,
          }}
          onClick={!plusIconDisabled ? func : undefined}
          icon={<FluentUiIcon name={"AddRegular"} color={"#000"} size={12} disabled={plusIconDisabled} />}
        />
  );
};

PlusIcon.propTypes = {
  func: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  projectId: PropTypes.number,
};

export default PlusIcon;
